import { Reveal, Eyebrow } from "../Reveal";
import { BENEFITS } from "../../lib/data";

const WhyUs = () => (
  <section data-testid="why-us-section" className="border-t border-black/10 bg-ink-surface">
    <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-32">
      <Reveal>
        <Eyebrow>Why Petroline Services</Eyebrow>
        <h2 className="max-w-2xl font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          Why Work With Petroline Services?
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {BENEFITS.map((benefit, i) => (
          <Reveal key={benefit.title} delay={(i % 3) * 0.1} className="h-full">
            <div
              data-testid={`benefit-card-${benefit.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group h-full border border-black/10 bg-white p-8 transition-colors duration-300 hover:border-ember/60"
            >
              <benefit.icon className="h-7 w-7 text-ember" />
              <h3 className="mt-6 font-display text-lg font-bold tracking-tight">{benefit.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-mist">{benefit.description}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
